//there is some functionality that different modals that get displayed in the control bar all use
/**
 * Converts the provided time string (like HH:MM:SS or MM:SS) into the number of milliseconds
 * @param {string} durationDisplay
 */
export function getMsFromString(durationDisplay) {
    var i, segments = durationDisplay.split(":");

    //if the first segement only has one digit for hours, add a padding 0 to the front of it
    if (segments[0].length === 1) {
        segments[0] = `0${segments[0]}`;
    }

    for (i = 0; i < segments.length; i++) {
        if (isNaN(parseInt(segments[i], 10)) || segments[i].length != 2 || segments[i] < 0) {
            return -1;
        }
    }

    var timeInMS = 0;

    switch (segments.length) {
        case 3:
            timeInMS = segments[0] * 3600000 + segments[1] * 60000 + segments[2] * 1000;
            break;
        case 2:
            timeInMS = segments[0] * 60000 + segments[1] * 1000;
            break;
        case 1:
            timeInMS = segments[0] * 1000;
            break;
    }

    return timeInMS;
}

/**
 * Mirrors the checkbox 'checked' attribute to the field 'interactable' attribute.
 */ 
export function enableFieldByCheckbox(field, checkbox) {
    field.disabled = !checkbox.checked;

    // When timeCheckbox changes, toggle timeField disabled
    checkbox.addEventListener('change', event => {
        field.disabled = !checkbox.checked;
        field.required = checkbox.checked;
    });
}
/**
 * Adds padding of 0s before the time given.
 * If our video is longer than an hour, add enough padding for hours.
 * Else, keep it to just minutes and seconds.
 * @param {function} formattingMethod (videojs.formatTime)
 */ 
export function padTimeBasedUponDuration(formattingMethod, time, duration) {
    let needPadding = false;
    let guide = 600;

    //the normal time formatting only include one digit for hours
    //if the video is longer than 10 hours, add a tens digit for hours
    if (duration >= 36000) {
        needPadding = true;
        guide = 3600;
    } else if (duration >= 3600) {
        guide = 3600;
    }

    let formattedString = formattingMethod(time, guide);

    if (needPadding) {
        formattedString.padStart(8, '0');
    }
    return formattedString;
}

/**
 * Returns a regex that matches the format of the string to make sure its value is in the same format before submitting.
 */ 
export function createValidationForTimeString(formattedString) {
    let segments = formattedString.split(":");

    if (segments.length == 2) {
        return "^[0-5]\\d:[0-5]\\d$";
    } else if (segments.length == 3) {
        if (segments[0].length == 2) {
            return "^\\d\\d:[0-5]\\d:[0-5]\\d$";
        } else if (segments[0].length == 1) {
            return "^\\d:[0-5]\\d:[0-5]\\d$";
        }
    }

    return "";
}